export function incomeRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_INCOME_START":           
        case "FETCH_INCOMES_START":                                 
        case "UPDATE_INCOME_START":                                 
        case "DELETE_INCOME_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_INCOME_FULFILLED":           
        case "FETCH_INCOMES_FULFILLED":                                 
        case "UPDATE_INCOME_FULFILLED":                                 
        case "DELETE_INCOME_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_INCOME_ERROR":
        case "FETCH_INCOMES_ERROR":
        case "UPDATE_INCOME_ERROR":
        case "DELETE_INCOME_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}